import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  menuPaper: {
    width: '240px',
  },
}));

export default useStyles;
